import { BaseTool } from './BaseTool';
import { ToolType } from '../types';

export class MarqueeTool extends BaseTool {
  public id: ToolType = 'marquee';
  public name = 'Marquee Selection Tool';
  public cursor = 'crosshair';

  private isSelecting = false;
  private startX = 0;
  private startY = 0;
  private currentX = 0;
  private currentY = 0;

  public onMouseDown(e: MouseEvent, canvasX: number, canvasY: number): void {
    this.isSelecting = true;
    this.startX = canvasX;
    this.startY = canvasY;
    this.currentX = canvasX;
    this.currentY = canvasY;
  }

  public onMouseMove(e: MouseEvent, canvasX: number, canvasY: number): void {
    if (!this.isSelecting) return;
    this.currentX = canvasX;
    this.currentY = canvasY;
    this.editor.renderOverlayOnly();
  }

  public onMouseUp(_e: MouseEvent): void {
    if (!this.isSelecting) return;
    this.isSelecting = false;

    const x = Math.min(this.startX, this.currentX);
    const y = Math.min(this.startY, this.currentY);
    const w = Math.abs(this.currentX - this.startX);
    const h = Math.abs(this.currentY - this.startY);

    if (w > 2 && h > 2) {
      this.editor.selection.setRect(x, y, w, h, this.editor.width, this.editor.height);
    } else {
      this.editor.selection.deselect();
    }

    this.editor.render();
  }

  public renderOverlay(ctx: CanvasRenderingContext2D): void {
    if (!this.isSelecting) return;

    const zoom = this.editor.zoom;
    const panX = this.editor.panX;
    const panY = this.editor.panY;

    const x = Math.min(this.startX, this.currentX) * zoom + panX;
    const y = Math.min(this.startY, this.currentY) * zoom + panY;
    const w = Math.abs(this.currentX - this.startX) * zoom;
    const h = Math.abs(this.currentY - this.startY) * zoom;

    ctx.save();
    ctx.setLineDash([4, 4]);
    ctx.strokeStyle = '#38bdf8';
    ctx.lineWidth = 1.5;
    ctx.strokeRect(x, y, w, h);
    ctx.fillStyle = 'rgba(56, 189, 248, 0.15)';
    ctx.fillRect(x, y, w, h);
    ctx.restore();
  }
}
